import FiltersCommand from "@/pages/(app)/returns/list/components/commands/filters-command";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import { Button } from "@babackapp/ui/components/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@babackapp/ui/components/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@babackapp/ui/components/popover";
import { ListFilter } from "lucide-react";
import { useState } from "react";
import { FilterName } from "../../utils/types";
import useTranslation from "@babackapp/translations/use-translation";
import HotKey from "@/components/hot-key";

export default function ReturnsDataTableFilter() {
  const t = useTranslation();
  const [selectedFilter, setSelectedFilter] = useState<
    FilterName | null | undefined
  >(null);
  const { filtersDefinition } = useReturnRequestsFilters();

  return (
    <Popover
      onOpenChange={(open) => {
        if (!open) setSelectedFilter(null);
      }}
    >
      <HotKey keyTrigger={"f"} description={t("misc.filters.title")}>
        <PopoverTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8">
            <ListFilter className="mr-2 h-4 w-4" />
            {t("misc.filters.title")}
          </Button>
        </PopoverTrigger>
      </HotKey>
      <PopoverContent className="p-0" align="start">
        {!selectedFilter && (
          <Command>
            <CommandInput placeholder="Filter..." />
            <CommandList>
              <CommandEmpty>{t("misc.noResultFound")}</CommandEmpty>
              <CommandGroup>
                {Array.from(filtersDefinition.entries()).map(
                  ([key, filterDefinition]) => {
                    return (
                      <CommandItem
                        key={key}
                        onSelect={() => {
                          setSelectedFilter(key);
                        }}
                      >
                        {filterDefinition.category.Icon && (
                          <filterDefinition.category.Icon
                            className={"mr-2 h-4 w-4"}
                          />
                        )}
                        <span>{filterDefinition.category.label}</span>
                      </CommandItem>
                    );
                  },
                )}
              </CommandGroup>
            </CommandList>
          </Command>
        )}
        {selectedFilter && (
          <FiltersCommand filterDefinitionKey={selectedFilter} />
        )}
      </PopoverContent>
    </Popover>
  );
}
